<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="section">
        <div class="columns is-vcentered">
          <div class="column is-2 is-offset-2">
            <img :src="`${event.imgUrl}`" style="width: 150px" />
          </div>
          <div class="column is-6">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <div class="has-text-centered has-margin-bottom-30">
                <h2 class="title">View Your Team</h2>
              </div>
              <div class="columns is-multiline">
                <div class="column is-6-desktop">
                  <p><strong>Team Name: </strong> {{ entry.teamname }}</p>
                </div>
                <div class="column is-6-desktop">
                  <p><strong>Category: </strong> {{ entry.category }}</p>
                </div>
                <div class="column is-6-desktop">
                  <p>
                    <strong>Captain: </strong> {{ entry.user.firstname }}
                    {{ entry.user.surname }}
                  </p>
                </div>
              </div>

              <b-table
                :data="members"
                :bordered="false"
                :striped="true"
                :narrowed="true"
                :hoverable="true"
                :loading="loading"
                :mobile-cards="true"
                class="has-margin-bottom-30"
              >
                <template slot-scope="props">
                  <b-table-column field="name" label="Name">
                    <div v-if="props.row.dependant">
                      <div style="color: #aaa; font-size: 0.8em">
                        {{ props.row.dependant.firstname }}
                        {{ props.row.dependant.surname }}
                      </div>
                      <div
                        style="
                          color: #ccc;
                          font-size: 0.8em;
                          text-transform: uppercase;
                        "
                      >
                        {{ props.row.dependant.gender }}
                      </div>
                    </div>
                    <div v-else>
                      {{ props.row.firstname }} {{ props.row.surname }}
                      <div style="color: #aaa; font-size: 0.8em">
                        {{ props.row.email }}
                      </div>
                      <div
                        style="
                          color: #ccc;
                          font-size: 0.8em;
                          text-transform: uppercase;
                        "
                      >
                        {{ props.row.gender }}
                      </div>
                    </div>
                  </b-table-column>

                  <b-table-column label="Account Linked" centered>
                    <b-icon
                      v-if="props.row.user"
                      class="text-success"
                      icon="check"
                    ></b-icon>
                    <b-icon
                      class="text-danger"
                      v-if="!props.row.user"
                      icon="close"
                    ></b-icon>
                  </b-table-column>

                  <b-table-column label="Waiver Accepted" centered>
                    <b-icon
                      class="text-success"
                      v-if="props.row.acceptwaiver"
                      icon="check"
                    ></b-icon>
                    <b-icon
                      class="text-danger"
                      v-if="!props.row.acceptwaiver"
                      icon="close"
                    ></b-icon>
                  </b-table-column>

                  <b-table-column
                    label="Judge"
                    centered
                    v-if="event.config.entryjudge"
                  >
                    <b-icon
                      class="text-success"
                      v-if="props.row.meta && props.row.meta.entryjudge"
                      icon="check"
                    ></b-icon>
                    <b-icon
                      class="text-danger"
                      v-if="
                        !props.row.meta ||
                        (props.row.meta && !props.row.meta.entryjudge)
                      "
                      icon="close"
                    ></b-icon>
                  </b-table-column>

                  <b-table-column
                    label="T-Shirt Size Set"
                    centered
                    v-if="event.config && !event.config.hideshirtoption"
                  >
                    <b-icon
                      class="text-success"
                      v-if="props.row.user && props.row.user.tshirtsize"
                      icon="check"
                    ></b-icon>
                    <b-icon
                      class="text-danger"
                      v-if="
                        !props.row.user ||
                        (props.row.user && !props.row.user.tshirtsize)
                      "
                      icon="close"
                    ></b-icon>
                  </b-table-column>
                </template>

                <template slot="empty">
                  <section class="section">
                    <div class="content has-text-grey has-text-centered">
                      <p>
                        <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                      </p>
                      <p>No team members yet.</p>
                    </div>
                  </section>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TeamMemberApi from "@/api/team-member";
import EventEntryApi from "@/api/event-entry";
export default {
  components: {},
  data() {
    return {
      loading: true,
      member: {},
      entry: {},
      event: {},
      members: [],
    };
  },
  async created() {
    this.entry = await EventEntryApi.getEventEntry(this.$route.params.id);
    if (this.entry) {
      this.event = this.entry.event;
    }
    this.members = await TeamMemberApi.membersForEntry(this.$route.params.id);
    this.loading = false;
  },
};
</script>
